/**
 * A Faixa da Empresa (FR-81, 11.7) na tela — **uma** fonte para a ficha e para a lista.
 *
 * `Record<Faixa, string>` é o guarda de exaustividade: uma faixa nova no contrato gerado reprova o
 * `tsc` aqui, e não numa das telas que a desenham.
 */

import type { Faixa } from './api'

export const ROTULOS_DA_FAIXA: Record<Faixa, string> = {
  ouro: 'Ouro',
  prata: 'Prata',
  bronze: 'Bronze',
}
